const ADMIN_BASENAME = '/admin';

export const stripAdminBasename = (pathname: string): string => {
    if (!pathname.startsWith(ADMIN_BASENAME)) {
        return pathname || '/';
    }

    const strippedPath = pathname.slice(ADMIN_BASENAME.length);
    if (!strippedPath) {
        return '/';
    }

    return strippedPath.startsWith('/') ? strippedPath : `/${strippedPath}`;
};
